import React, { useCallback, useState } from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useBlocks, useUi } from "@jelly/lesson";
import { Accordion, AccordionItem } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";

import { messages } from "./AboutTheArtist.messages";
import styles from "./AboutTheArtist.module.scss";

import * as appConfig from "appConfig";
import { GerrietBioModal } from "../components/GerrietBioModal";
import { SpatialCarousel } from "../../..";
import { PhotoView } from "../../../photo-view/PhotoView";

interface AboutTheArtist {
  title: string;
}

export const AboutTheArtist: React.FC<AboutTheArtist> = ({ title }) => {
  return (
    <Accordion allowMultiOpen={false} defaultOpen={["gerriet"]}>
      <AboutTheArtistContent title={title} />
    </Accordion>
  );
};

const AboutTheArtistContent: React.FC<AboutTheArtist> = ({ title }) => {
  const ui = useUi();
  const blocks = useBlocks();
  const { formatMessage } = useIntl();
  const [gerrietModalOpen, setGerrietModalOpen] = useState(false);

  const handleGerrietModalToggle = useCallback(() => setGerrietModalOpen((open) => !open), []);

  const accordion = (
    <div className={styles.accordion}>
      <ui.Scrollbars>
        <AccordionItem id="gerriet" title={formatMessage(messages.accordionItem1Title)} unmountChildrenWhenHidden>
          <div style={{ width: "100%", height: "142px" }}>
            <blocks.video src={"https://youtu.be/khTSr_ZJB5M?si=-7tFWYE6QG8peMLk"} provider={"youtube"} />
          </div>
          <p>{formatMessage(messages.accordionItem1Description)}</p>
          <ui.Button shape={"normal"} theme={"primary"} size={"small"} onClick={handleGerrietModalToggle}>
            {formatMessage(messages.bioNote)}
          </ui.Button>
        </AccordionItem>
      </ui.Scrollbars>
    </div>
  );

  return (
    <StandardCase title={title} leftComponent={accordion}>
      <div className={styles.gallery}>
        {/*// @ts-expect-error We cannot override layouts using Contexts :/*/}
        <SpatialCarousel controlsPosition={"bottom"}>
          {Array.from({ length: 4 }, (_, index) => (
            <PhotoView
              key={index}
              imgSrc={`${appConfig.STATIC_ASSETS_URL}/lms/case/case03/about-the-artist/${index + 1}.jpg`}
              // @ts-expect-error :/*/
              description={formatMessage(messages[`galleryItem${index + 1}Description`])}
              imgMode={"contain"}
            />
          ))}
        </SpatialCarousel>
      </div>
      <GerrietBioModal visible={gerrietModalOpen} onClose={handleGerrietModalToggle} />
    </StandardCase>
  );
};
